<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="flex-wrap d-flex" style="gap: 10px">
        <form class="col-md-12" @submit.prevent="handleSubmit(submit)">
          <ValidationProvider rules="required" vid="code" name="Mã code">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Mã code<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <Select2 v-model="form.code" :options="codes" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="name" name="Tên">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Tên:<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="form.name" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="url" name="Đường dẫn">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Đường dẫn:<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="form.url" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </div>
      <button @click="handleSubmit(submit)" class="btn btn-success float-right">Lưu</button>
    </ValidationObserver>
    <VueLoadingOverlay
      style="z-index: 5 !important"
      :active.sync="showLoading"
      :is-full-page="false"
    ></VueLoadingOverlay>
  </div>
</template>
<script>
  import { RoleService } from '@/services/role.service'
  import { MdService } from '@/services/md.service'

  export default {
    props: {
      id: {
        type: String,
      },
      items: {
        type: Object,
      },
    },
    data() {
      return {
        showLoading: false,
        codes: [],
        form: {},
      }
    },
    async created() {
      try {
        this.showLoading = true
        const permissions = await RoleService.getListPermission()
        this.codes = Object.values(permissions.data)
          .flat()
          .map(s => ({ id: s.code, text: `${s.code} - ${s.name}` }))
        if (this.id) {
          this.form = {
            code: this.items.code,
            id: this.items.id,
            name: this.items.name,
            url: this.items.url,
          }
        }
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async submit() {
        try {
          this.showLoading = true
          if (this.id) {
            const res = await MdService.update(this.form)
            if (res.success === true) {
              this.showSuccessMx('Cập nhật thành công').then(s => {
                this.$bvModal.hide('MenuRequest')
              })
            } else this.showFailMx(res.message ?? res.error)
          } else {
            const res = await MdService.create(this.form)
            if (res.success === true) {
              this.showSuccessMx('Tạo mới thành công').then(s => {
                this.$bvModal.hide('MenuRequest')
              })
            } else this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped></style>
